var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wd-empty-data radius30"},[_vm._t("emptyImg",function(){return [_c('img',{attrs:{"src":_vm.src}})]}),_vm._t("emptyText",function(){return [_c('p',[_vm._v(_vm._s(_vm.text))])]}),_vm._t("emptyHandle")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }